import { useNavigate } from 'react-router-dom';
import { PQRWEB } from '../../../../../../routes/paths';

export const useModalCreate = () => {
    const navigate = useNavigate();

    const handleClose = () => {
        navigate(PQRWEB);
    };

    return {
        handleClose,
    };
};
